module.exports = __webpack_public_path__ + "img/camp_shirt_gk6.ca09a706.svg";